/**
 * 金融機関検索
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'
 
 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/banks`
 
 const search_bank = {
   namespaced: true,
   state: {},
   getters: {},
   actions: {
     /**
      * 金融機関一覧の取得.
      * ドロップダウンで表示可能な内容を返します.
      * @return {Promise<unknown>}
      */
      index () {
        return new Promise((resolve) => {
          Vue.$http.get(API_PATH).then(data => {
            resolve(data.content)
          })
        })
      },
     /**
      * 金融機関情報の取得.
      * @param commit
      * @param { String } id コード
      * @return {Promise<unknown>}
      */
     show ({ commit }, { code }) {
       const api_path = `${API_PATH}/${code}`
       return new Promise((resolve) => {
         Vue.$http.get(api_path).then(data => {
           resolve(data.content)
         })
       })
     },
   },
   mutations: {},
 }
 export default search_bank
 